// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8df7b763","239":"32703d84","455":"af0c8d90"}[chunkId] + ".chunk.js";
};